export default __webpack_public_path__ + "static/media/kanban1.8a4567bc.png";